module.exports = __webpack_public_path__ + "static/VIRIYAH.defd0c95.png";